import { render, staticRenderFns } from "./ReadOnlyField.vue?vue&type=template&id=5bd2c5fa&scoped=true&"
import script from "./ReadOnlyField.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyField.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyField.vue?vue&type=style&index=0&id=5bd2c5fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2c5fa",
  null
  
)

export default component.exports